import { QueryObserverResult, useQuery } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';

import {
  API_QUERY_KEYS,
  getFilterStatuses,
  GetFilterStatusesResponse,
  QueryDefaults,
} from 'api';
import { filterArchiveRequestState } from 'store';

export const useFilterStatuses = (): QueryObserverResult<GetFilterStatusesResponse> => {
  const request = useRecoilValue(filterArchiveRequestState);
  return useQuery(
    [API_QUERY_KEYS.getFilterStatuses, request],
    () => getFilterStatuses(request),
    QueryDefaults
  );
};
